import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = ["src"];
import { ref } from 'vue';
import constants from '@/constants';
import cartUtils from '../cartUtils';
import { useRouter } from 'vue-router';
import imageLink from '@/configs/imageLink';
import { clickEvents } from '@/configs/awsRumConfig';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { isLoginAuthenticated } from '@/utils/common';
export default {
  __name: 'FreeShippingTips',
  setup(__props, {
    expose: __expose
  }) {
    const {
      YELLOW_ARROW_RIGHT
    } = imageLink;
    const {
      FREE_SHIPPING
    } = constants.Common;
    const router = useRouter();
    const freeShippingTipsRef = ref(null);

    // Shopping cart data processing function
    const {
      selectList,
      freeShipping,
      isHiddenBottomArea
    } = cartUtils.cartState;
    const goToAddOnItem = async () => {
      selectList.value.forEach(item => {
        awsRumHandler.recordClickEvent({
          ...clickEvents.cartPage.getFreeShipping_btn,
          asinid: item.asin
        });
      });
      if (!(await isLoginAuthenticated())) return;
      isHiddenBottomArea.value = true;
      router.push({
        name: 'addOnItem'
      });
    };
    __expose({
      element: freeShippingTipsRef
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "free-shipping-tips bottom-label row-space",
        ref_key: "freeShippingTipsRef",
        ref: freeShippingTipsRef
      }, [!_unref(freeShipping).isFreeShipping ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('modules.cart.SAVE_SHIPPING_FEE.REPURCHASE') + _ctx.$t('common.currencyUnit') + (_unref(FREE_SHIPPING).FREE_SHIPPING_THRESHOLD - _unref(freeShipping).amountFromFSThreshold).toFixed(2) + ' ' + _ctx.$t('modules.cart.SAVE_SHIPPING_FEE.TO_QUALIFY_FOR_FREE_SHIPPING')), 1), _createElementVNode("span", {
        onClick: goToAddOnItem
      }, [_createTextVNode(_toDisplayString(_ctx.$t('modules.cart.EXPLORE_MORE')) + " ", 1), _createElementVNode("img", {
        class: "right-arrow",
        src: _unref(YELLOW_ARROW_RIGHT),
        alt: ""
      }, null, 8, _hoisted_1)])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('modules.cart.SAVE_SHIPPING_FEE.QUALIFIES_FOR_FREE_SHIPPING_OVER') + _ctx.$t('common.currencyUnit') + _unref(FREE_SHIPPING).FREE_SHIPPING_THRESHOLD), 1), _createElementVNode("span", {
        onClick: goToAddOnItem
      }, [_createTextVNode(_toDisplayString(_ctx.$t('modules.cart.EXPLORE_MORE')) + " ", 1), _createElementVNode("img", {
        class: "right-arrow",
        src: _unref(YELLOW_ARROW_RIGHT),
        alt: ""
      }, null, 8, _hoisted_2)])], 64))], 512);
    };
  }
};